export default __webpack_public_path__ + "static/media/veg.cfe4b63b.png";